import {
    REQUEST_CONTRACTS,
    RECEIVE_CONTRACTS,
    UPDATE_CONTRACTS,
    RELOAD_CONTRACTS,
    ERROR_CONTRACTS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"
import _merge from "lodash/merge"

export default (state = initialFetchState, action = {}) => {

    switch(action.type) {
        case REQUEST_CONTRACTS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_CONTRACTS:
            return {
                ...state,
                isFetching: false,
                shouldReload: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case RELOAD_CONTRACTS:
            return {
                ...state,
                shouldReload: true
            }
        case UPDATE_CONTRACTS:
            const data = state.data
            let index = null

            switch(action.updateType) {
                case 'create':
                    if(!data.results){
                        data.results = []
                    }
                    data.results.unshift(action.payload)
                    break
                case 'update':
                    if(data.results){
                        index = data.results.findIndex(item => item.id == action.id)
                        data.results[index] = action.payload
                    }
                    break
                case 'merge':
                    if(data.results){
                        index = data.results.findIndex(item => item.id == action.id)
                        data.results[index] = _merge(data.results[index], action.payload)
                    }
                    break
            }
            return {
                isFetching: false,
                shouldReload: false,
                data,
                errors: action.errors
            }
        case ERROR_CONTRACTS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}